import { Component } from 'nospa';

export default class HeroAlert extends Component {
  onInit() {
    this.closeRef = this.$getRef('close');
    this.hide = this.hide.bind(this);
    this.setEvents();
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';

    if (this.closeRef) {
      this.closeRef.el[action]('click', this.hide);
    }
  }

  hide() {
    this.$el.parentNode.removeChild(this.$el);
    // TODO: set cookie or something else
    this.setEvents(false);
  }

  onDestroy() {
    this.setEvents(false);
  }
}
